<div *ngIf="orgName" class="card-sm shadow-sm rounded-4 border-0 mb-2 parent-org-card">
  <div class="card-body py-3 px-4">
    <h6 class="mb-0 text-primary parent-org-title">
      Parent Organization: {{ orgName }}
    </h6>
  </div>
</div>

<div class="user-table-container">
  <div *ngIf="showSuccess" class="success-message-top">
    <span class="badge bg-success">The user is updated!</span>
  </div>
  <table class="table table-bordered table-striped">
    <thead>
      <tr>
        <th>Edit</th>
        <th>Username</th>
        <th>First Name</th>
        <th>Last Name</th>
        <th>Active</th>
        <th>Email</th>
        <th>Exclude Referrals</th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let user of pagedUsers">
        <td>
          <button mat-icon-button (click)="onEditUser(user)">
            <mat-icon>edit</mat-icon>
          </button>
        </td>
        <td>{{ user?.username || "-" }}</td>
        <td>{{ user?.firstname || "-" }}</td>
        <td>{{ user?.lastname || "-" }}</td>
        <td>
          <input type="checkbox" [checked]="user?.active ?? true" disabled />
        </td>
        <td>{{ user?.email || "-" }}</td>
        <td>
          <input type="checkbox" [checked]="user?.excludeReferrals ?? false" disabled />
        </td>
      </tr>
    </tbody>
  </table>
  <div class="pagination-container">
    <button (click)="prevPage()" [disabled]="currentPage === 1">Prev</button>
    <ng-container *ngFor="let page of [].constructor(totalPages); let i = index">
      <button (click)="goToPage(i + 1)" [class.active-page]="currentPage === i + 1">
        {{ i + 1 }}
      </button>
    </ng-container>
    <button (click)="nextPage()" [disabled]="currentPage === totalPages">
      Next
    </button>
  </div>
</div>